// @flow

import { authenticatedFetch } from '../../api/request';

export default function sendToTelemetry(
    key: string,
    payload: any,
    sendToSegment: boolean
) {
    const url = '/v5/telemetry/track';

    return authenticatedFetch(url, {
        method: 'POST',
        body: JSON.stringify({
            value: payload,
            key,
            source: 'mobile',
            sendToSegment
        })
    });
}



// WEBPACK FOOTER //
// ./src/lib/segment/sendToTelemetry.js